import styled from "styled-components";

export const CourierSelectorBtn = styled.div`
  border-radius: 10px;
  background-color: transparent !important;
  border: ${(props) => props.theme.color.primary} 2px solid !important;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
`;
